import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, MenuItem, Alert
} from '@mui/material';
import { updateCamera } from '../../../services/cameraService';


const EditCameraDialog = ({ open, onClose, onEdit, initialData }) => {
  const [form, setForm] = useState({
    camera_name: '',
    type_of_career: '',
    qualification: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Pre-fill form on open
  useEffect(() => {
    if (initialData) {
      setForm({
        camera_name: initialData.camera_name || '',
        type_of_career: initialData.type_of_career || '',
        qualification: initialData.qualification || '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      await updateCamera(initialData.camera_id || initialData.id, form);
      onEdit(); // refresh parent
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to update camera.');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Camera</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          name="camera_name"
          label="Name"
          value={form.camera_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          select
          name="type_of_career"
          label="Type"
          value={form.type_of_career}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        >
          <MenuItem value="admin">Administrator</MenuItem>
          <MenuItem value="nurse">Nurse</MenuItem>
          <MenuItem value="carer">Carer</MenuItem>
        </TextField>
        <TextField
          name="qualification"
          label="Qualification"
          value={form.qualification}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained" color="primary">
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCameraDialog;
